import Skeleton from "../../../Components/Common/Skeleton/Skeleton";

const ROWS = [0, 1, 2, 3, 4];

const SubContractorTableSkeleton = () => (
  <div className="plist table-responsive">
    <table className="table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Phone</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {ROWS.map((i) => (
          <tr key={i}>
            <td>
              <Skeleton width={140} height={13} borderRadius={undefined} />
            </td>
            <td>
              <Skeleton width={180} height={13} borderRadius={undefined} />
            </td>
            <td>
              <Skeleton width={110} height={13} borderRadius={undefined} />
            </td>
            <td>
              <div className="rowActions">
                <Skeleton width={44} height={28} borderRadius="5px" />
                <Skeleton width={58} height={28} borderRadius="5px" />
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default SubContractorTableSkeleton;
